import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  textColor?: string; 
}

const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  size = 'md',
  textColor = 'text-slate-700'
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const logoSizeClass = size === 'sm' ? 'h-8' : size === 'lg' ? 'h-16' : 'h-12';
  const textSize = size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-3xl' : 'text-xl';
  const gap = size === 'sm' ? 'gap-2' : size === 'lg' ? 'gap-4' : 'gap-3';

  const handleLogoClick = () => {
    const path = location.pathname;
    
    if (path.startsWith('/system')) {
      navigate('/system/dashboard');
    } else if (path.startsWith('/admin')) {
      navigate('/admin/shifts');
    } else if (path.startsWith('/user')) {
      navigate('/user/shifts');
    } else {
      navigate('/login');
    }
  };

  return (
    <div 
      className={`inline-flex items-center ${gap} select-none ${className} cursor-pointer hover:opacity-80 transition-opacity`} 
      onClick={handleLogoClick}
      title="ホームへ戻る"
    >
      <div className={`${logoSizeClass} w-auto flex-shrink-0`}>
        <svg 
            className="h-full w-auto"
            viewBox="0 0 129 128" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Shiftmate Logo"
        >
            <path d="M69.7884 25.1023C76.7532 25.1023 82.3992 19.483 82.3992 12.5512C82.3992 5.61934 76.7532 0 69.7884 0C62.8237 0 57.1776 5.61934 57.1776 12.5512C57.1776 19.483 62.8237 25.1023 69.7884 25.1023Z" fill="#305EF1"/>
            <path d="M55.3892 26.8642C50.4799 21.9781 42.4681 21.9781 37.5588 26.8642L3.66841 60.5943C-1.24087 65.4803 -1.24087 73.4542 3.66841 78.3403C8.57768 83.2263 16.5895 83.2263 21.4987 78.3403L55.3892 44.6102C60.2984 39.7241 60.2984 31.7502 55.3892 26.8642Z" fill="#4BBDFB"/>
            <path d="M116.016 71.1112C122.981 71.1112 128.627 65.4918 128.627 58.56C128.627 51.6282 122.981 46.0089 116.016 46.0089C109.051 46.0089 103.405 51.6282 103.405 58.56C103.405 65.4918 109.051 71.1112 116.016 71.1112Z" fill="#FFCD7D"/>
            <path d="M101.617 72.873C96.7073 67.987 88.6955 67.987 83.7862 72.873L49.8958 106.603C44.9865 111.489 44.9865 119.463 49.8958 124.349C54.8051 129.235 62.8169 129.235 67.7262 124.349L101.617 90.619C106.526 85.7329 106.526 77.7591 101.617 72.873Z" fill="#FF7A59"/>
            <path d="M35.6972 105.023C42.662 105.023 48.308 99.4035 48.308 92.4717C48.308 85.5399 42.662 79.9205 35.6972 79.9205C28.7325 79.9205 23.0864 85.5399 23.0864 92.4717C23.0864 99.4035 28.7325 105.023 35.6972 105.023Z" fill="#164E65"/>
            <path d="M101.799 26.6826C96.8898 21.7965 88.878 21.7965 83.9687 26.6826L50.0783 60.4127C45.169 65.2987 45.169 73.2726 50.0783 78.1587C54.9876 83.0447 62.9994 83.0447 67.9086 78.1587L101.799 44.4286C106.708 39.5425 106.708 31.5686 101.799 26.6826Z" fill="#1DDDCE"/>
        </svg>
      </div>

      <span 
        className={`font-bold tracking-tight ${textSize} ${textColor}`}
        style={{ fontFamily: '"Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, "Helvetica Neue", Arial, sans-serif' }}
      >
        シフトメイト
      </span>
    </div>
  );
};

export default Logo;